module.exports = __webpack_public_path__ + "static/media/arrow-go-back.8780d42b.svg";